<div class="search-page-layout">
    <div class="search-page-layout__container">
        <h1 class="search-page-layout__container__title">
            <ds-icon
                [icon]="titleIcon"
                [size]="titleIconSize"></ds-icon>
            <ng-content select="[layout-title]"></ng-content>
        </h1>

        <div class="search-page-layout__container__content">
            <div class="search-page-layout__container__content__filters">
                <div class="search-page-layout__container__content__filters__body">
                    <ng-content select="[layout-filters]"></ng-content>
                </div>
                <div class="search-page-layout__container__content__filters__actions">
                    <ng-content select="[layout-action]"></ng-content>
                </div>
            </div>

            <div class="search-page-layout__container__content__results">
                <ng-content select="[layout-results]"></ng-content>
            </div>
        </div>
    </div>
</div>
